import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { RadioGroup } from "@jti/ui/components/Radio";
import { TitleBorderContainer } from "@jti/ui-library";
import { ConsentBenefitsList, ConsentRadioInput } from "./components";
import styles from "./ConsentBlock.module.scss";
export const ConsentBlock = ({ onChange, showError, agreeRadioLabel, rejectRadioLabel, consentSectionTitle, consentSectionSubtitle, ...rest }) => {
    const onRadioGroupChange = (_, value) => {
        onChange(value === "true");
    };
    const radioGroup = (_jsx(RadioGroup, { name: "consent-radio-group", onChange: onRadioGroupChange, children: _jsxs("div", { className: styles.radioGroupGrid, children: [_jsx(ConsentRadioInput, { value: true, label: agreeRadioLabel }), _jsx(ConsentBenefitsList, { ...rest }), _jsx(ConsentRadioInput, { value: false, label: rejectRadioLabel })] }) }));
    return (_jsx(TitleBorderContainer, { title: consentSectionTitle, subtitle: consentSectionSubtitle, className: classNames(showError && styles.error), marginBottom: "16px", testId: "pdp-consent-block", children: radioGroup }));
};
//# sourceMappingURL=ConsentBlock.js.map